import type { ApiOrg } from '@/types/org';
import type { ApiPermission } from '@/types/permissions';
import { User, type ApiUser } from '@/types/users';

export interface AxleAuthRequest {
  token: string;
}

export const AXLE_TOKEN_TYPES = [
  'SHORT',
  'UNITY_W',
] as const;

type AxleTokenType = typeof AXLE_TOKEN_TYPES[number];

export interface AxleOutgoingTokenRequest {
  token_type: AxleTokenType;
}

export interface SwapAxleTwrnRequest {
  axle_twrn: string;
}

export interface SwapAxleTwrnResponse {
  twrn: string;
}

export interface ApiImpersonator {
  first_name: string;
  last_name: string;
}

export interface ApiLoginResponse {
  impersonator: ApiImpersonator | null;
  token: Token;
  user_data: {
    user: ApiUser;
    org: ApiOrg;
    permissions: ApiPermission[];
  };
}

export interface Token {
  token: string;
  expires_at: string;
}

export type Impersonator = string;

export class LoginResponse {
  impersonator: Impersonator | null;
  token: Token;
  user: User;
  org: ApiOrg;
  permissions: ApiPermission[];

  constructor(data: ApiLoginResponse) {
    this.impersonator = data.impersonator
      ? `${data.impersonator.first_name} ${data.impersonator.last_name}`
      : null;
    this.token = data.token;
    this.user = new User(data.user_data.user);
    this.org = data.user_data.org;
    this.permissions = data.user_data.permissions;
  }
}
